module.exports = __webpack_public_path__ + "media/images/arrow-right-white-e487eea79309fe9969ef646e15dd0d81.png";